import { render, staticRenderFns } from "./TicketsGroup.vue?vue&type=template&id=16bb1658&scoped=true&"
import script from "./TicketsGroup.vue?vue&type=script&lang=js&"
export * from "./TicketsGroup.vue?vue&type=script&lang=js&"
import style0 from "./TicketsGroup.vue?vue&type=style&index=0&id=16bb1658&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bb1658",
  null
  
)

export default component.exports